// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-settings-dialog-container .mat-button-toggle-group .mat-button-toggle {
  height: 2.7rem;
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/dialogs/theme-settings-dialog/theme-settings-dialog.component.scss"],"names":[],"mappings":"AAEE;EACC,cAAA;EACA,aAAA;EACA,mBAAA;AADH","sourcesContent":[".theme-settings-dialog-container {\n\t.mat-button-toggle-group {\n\t\t.mat-button-toggle {\n\t\t\theight: 2.7rem;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
